module.exports = __webpack_public_path__ + "static/img/avatar.a99a33fb.png";